import { ActionBase } from '../../../core/store/action/ActionBase';
import { LookupModel } from '../../../common/models/LookupModel';

export const GET_NOTIFICATION_TYPES_SUCCESS = '[Customer] User Get Notification Types Success';

export class GetNotificationTypesSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_NOTIFICATION_TYPES_SUCCESS;

  constructor(public payload: { notificationTypes: LookupModel[] }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/GetNotificationTypesSuccessAction.ts